var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-overlay',{staticClass:"12",attrs:{"value":_vm.overlay}},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary","size":"64"}})],1),(!_vm.overlay)?_c('router-view'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }